import { FN_CANVAS__draw_badge } from './FN_CANVAS__draw_badge';
import { FN_CANVAS__draw_fit_image } from './FN_CANVAS__draw_fit_image';
import { PROPS__draw_mode_params } from './PROPS__draw_mode_params';

/** Mode 3: Pixel Difference */
export function FN_CANVAS__apply_image_compare__difference({ ctx, width, height, image_a, image_b, fitAR }: PROPS__draw_mode_params) {
  const targetAspectB: number = fitAR && image_a ? image_a.naturalWidth / image_a.naturalHeight : NaN;

  FN_CANVAS__draw_fit_image(ctx, image_a, 0, 0, width, height);
  ctx.globalCompositeOperation = 'difference';
  FN_CANVAS__draw_fit_image(ctx, image_b, 0, 0, width, height, targetAspectB);
  ctx.globalCompositeOperation = 'source-over';

  ctx.fillStyle = 'rgba(72, 255, 132, 0.15)';
  ctx.fillRect(0, 0, width, height);

  FN_CANVAS__draw_badge(ctx, 'A', 20, 20);
  FN_CANVAS__draw_badge(ctx, 'B', width - 20, 20);
}
